<template>
  <transition-group class="transition-list" name="list" tag="ul">
    <slot />
  </transition-group>
</template>

<script>
export default {
  name: 'TransitionList'
}
</script>

<style lang="scss">
.list-enter-active, .list-leave-active {
  transform-origin: right center;
  transition: opacity .35s, transform .5s ease-in-out;
}

.list-enter {
  opacity: 0;
  transform: translateX(25%);
}

.list-leave-to {
  opacity: 0;
  transform: translateX(-25%);
}
</style>
